var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3a9 9 0 100 18 9 9 0 000-18zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9a3 3 0 100 6 3 3 0 000-6zm-5 3a5 5 0 1110 0 5 5 0 01-10 0z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.223 4.223a1 1 0 011.414 0l4.24 4.24a1 1 0 01-1.414 1.414l-4.24-4.24a1 1 0 010-1.414zM14.123 14.123a1 1 0 011.414 0l4.24 4.24a1 1 0 01-1.414 1.414l-4.24-4.24a1 1 0 010-1.414zM19.777 4.223a1 1 0 010 1.414l-4.24 4.24a1 1 0 01-1.414-1.414l4.24-4.24a1 1 0 011.414 0z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.067 4.933a1 1 0 010 1.414l-3.53 3.53a1 1 0 01-1.414-1.414l3.53-3.53a1 1 0 011.414 0zM9.877 14.123a1 1 0 010 1.414l-4.24 4.24a1 1 0 01-1.414-1.414l4.24-4.24a1 1 0 011.414 0z",
    fill: "#000"
  })));
}
export default SvgSupport;